module.exports = __webpack_public_path__ + "img/banner.3fd01366.png";